import PropTypes from "prop-types"
import { axiosRequest } from "utils/api"
import { pluralize } from "utils/helpers"
import { Box, Button } from "@planningcenter/tapestry-react"

const PotentialAttendeeAlert = ({
  eventId,
  attendanceReport: {
    data: {
      id,
      attributes: { potential_attendees_count: count, filters = [] },
      relationships: { potential_attendees: { data: newAttendees } = {} } = {}
    }
  }
}) => {
  const handleAddToRoster = () => {
    const attendeeIds = newAttendees.map(att => att.id)

    alertModal(
      {
        title: "Add new attendees to roster?",
        text: `This will add new entries to your existing attendance roster`,
        type: "warning",
        confirmButtonText: "Yes, add them!",
        cancelButtonText: "Cancel",
        showCancelButton: true
      },
      () =>
        axiosRequest("POST", `events/${eventId}/attendance_reports/${id}/add_attendees`, {
          attendance_report_id: id,
          attendee_ids: attendeeIds
        }).then(_resp => {
          return Turbolinks.visit(document.location)
        })
    )
  }

  const renderHeaderCopy = () => {
    if (filters.length) {
      return (
        <div>
          {count} {pluralize("attendee", "attendees", count, false)} matching this roster&apos;s
          filters {pluralize("has", "have", count, false)} registered since this roster was created
        </div>
      )
    } else {
      return (
        <div>
          {count} {pluralize("attendee has", "attendees have", count, false)} registered since this
          roster was created
        </div>
      )
    }
  }

  return (
    count > 0 && (
      <div className="alert info-alert">
        <Box marginBottom={1}>{renderHeaderCopy()}</Box>
        <Button theme="app" size="sm" onClick={handleAddToRoster} title="Add to roster" />
      </div>
    )
  )
}

PotentialAttendeeAlert.propTypes = {
  eventId: PropTypes.number,
  attendanceReport: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number,
      attributes: PropTypes.shape({
        potential_attendees_count: PropTypes.number
      }),
      relationships: PropTypes.shape({
        potential_attendees: PropTypes.shape({
          data: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string
            })
          )
        })
      })
    })
  })
}

export default PotentialAttendeeAlert
